export default __webpack_public_path__ + "static/media/ghost.f4f9a780.svg";